import { useCallback, useContext, useEffect, useState } from "react";
import { DraftContext } from "../context/DraftContext";
import forms from "../components/form-container/forms/forms";
import { TYPES } from "../../../config/constants/typesReducers";
import { FddApi } from "../../../ui/services/server-fdd";
import { useLocation } from "react-router-dom";
import { getIdFromPath } from "../../../ui/utils/getIdFromPath";
import LocalStorage from "../../../ui/utils/LocalStorage";
import { GlobalContext } from "../../../ui/context/global/GlobalContext";

const { DRAFT } = TYPES;

//? Este hook se encarga de manejar el flujo de los formularios
export const useStepForms = (parentRef) => {
    const location = useLocation();
    
    const {socketRef} = useContext(GlobalContext);
    const {draftState, draftDispatch} = useContext(DraftContext);
    
    const [currentStep, setStep] = useState(0);
    const [canReturnHome, setCanReturnHome] = useState(false);

    const [ formSubmissionStatus, setFormSubmissionStatus ] = useState({
        response:{
            message: '',
            hasError: false
        },
        streamProgress: [
            {message: 'Actualizando solicitud...', status: 'pending', hasError: false},
            {message: 'Creando espacio para los firmantes...', status: 'pending', hasError: false},
            {message: 'Enviando correos a los firmantes...', status: 'pending', hasError: false},
        ],
    });

    const currentForm = forms[currentStep];

    const onRecivedData = useCallback(({step, message, hasError}) => {
        console.log('Mensaje Recibido ->', message);

        setFormSubmissionStatus((prevData) => {
            const { streamProgress } = prevData;

            return ({
                ...prevData,
                streamProgress: streamProgress.map((item, index) => {
                    return index === step 
                    ? {
                        ...item,
                        status: 'completed', 
                        hasError
                    } : item
                })
            });
            
        });
        console.log(formSubmissionStatus.streamProgress);
    },[formSubmissionStatus]);

    const sendForm = useCallback(async(setIsLoading) =>{
        // INICIA EL PROCESO DE ENVIO DEL FORMULARIO
        setIsLoading(true);
        
        try{
            // Guarda el draft en localStorage
            LocalStorage.setLocalDraft({
                isFinished: true,
                draftId: getIdFromPath(location.pathname),
                draft: draftState.draft
            });

            // Busca la instancia del socket
            const currentSocket = socketRef.current;

            // Si el socket esta conectado, escucha los datos del proceso
            if (currentSocket.socket.connected) currentSocket.listenProcess(onRecivedData);

            const response = await FddApi.sendDraft(
                getIdFromPath(location.pathname),
                currentSocket.getSocketId(),
                draftState.draft
            );

            if (response.hasError) throw new Error(response.message);

            setFormSubmissionStatus((prevData) => {
                setCanReturnHome(true);
                return ({
                ...prevData,
                response: {
                    message: response.message,
                    hasError: response.hasError
                }})
            });

        } catch(error){
            console.error('Error al enviar formulario', error);

            setFormSubmissionStatus((prevData) => {
                setCanReturnHome(false);
                return ({
                ...prevData,
                response: {
                    message: error.message,
                    hasError: true
                }})
            });

        } finally {
            console.log('Finalizando proceso de envío del formulario', canReturnHome);
            setIsLoading(false);
            // Si no se ha producido un error, se puede volver al formulario
        }
    }, [draftState.draft, socketRef, location.pathname, onRecivedData, canReturnHome, setCanReturnHome]);

    // Si se encuentra en el formulario de campos, se permite editar
    useEffect(() => {
        currentForm.title === "Agregar Campos"
        ? saveFormReducer(draftDispatch, DRAFT.CAN_EDIT, true)
        : saveFormReducer(draftDispatch, DRAFT.CAN_EDIT, false);
    },[currentForm, draftDispatch]);

    // Guarda el draft en localStorage si ocurre un cambio inesperado
    useEffect(() => {
        if (!parentRef.current) return;
        
        LocalStorage.setLocalDraft({
            isFinished: false,
            draftId: getIdFromPath(location.pathname),
            draft: draftState.draft
        });
    }, [draftState.draft, parentRef, location.pathname]);

    const handleSubmitForm = useCallback(async(isLastForm, setIsLoading) => {
        event.preventDefault();
        console.log('Try Again? ', isLastForm);

        if (currentStep >= forms.length || currentStep < 0) return;

        if (currentStep === forms.length - 1){
            sendForm(setIsLoading);
            return;
        }

        setStep(currentStep + 1);

        if (!isLastForm) return;
        sendForm(setIsLoading)
        
    },[currentStep, sendForm]);

    const handleBackForm = () => setStep(currentStep - 1);

    return ({
        currentForm,
        currentProgress: currentStep + 1,
        hideBackButton: currentStep === 0 || canReturnHome,
        isFieldsForm: currentStep === forms.length - 3,
        isLastForm: currentStep >= forms.length - 2,
        isReviewForm: currentStep === forms.length - 1,
        canReturnHome,
        formSubmissionStatus,
        handleSubmitForm,
        handleBackForm,
    });
}

const saveFormReducer = (dispatch, type, payload) => {
    dispatch({
        type: type,
        payload: payload
    })
}